const constant = {
  // 管理员状态
  MANAGER_STATUS: {
    1: '停用',
    0: '启用'
  },
  ROLE_TYPE: {
    '1': '总部',
    '2': '项目',
  },
  ESTATE_TYPE: {
    '1': '项目',
    '2': '集团',
  },
  TALKBACK_TYPE: {
    '3': '楼宇机',
    '4': '室内机',
    '5': '大门',
  },
  // MANAGER_STATUS: {
  //   '1': '正常',
  //   '0': '停用',
  // },
  USER_STATUS: {
    '1': '正常',
    '9': '冻结',
  },
  SYSTEM: {
    '1': '梯控',
    '2': '门禁道闸',
  },
  USER_TYPE: {
    '1': '用户',
    //  '2': '租户',
    '3': '访客',
  },
  MANAGER_LEVEL: {
    '1': '公司管理员',
    '2': '项目管理员',
  },
  DOWNLOAD_OPTYPE: {
    '0': '初始化',
    '1': '新增',
    '2': '删除',
  },
  DOWNLOAD_STATUS: {
    '0': '未下载',
    '1': '成功',
    '2': '失败',
  },
  PUBLIC_YESNO: {
    '1': '是',
    '0': '否',
  },
  ROOM_RULE: {
    1: '0000【前两位楼层号后两位房间号】',
    2: '00字母【前两位楼层号加字母】',
  },
  CAMERA_TYPE: {
    '1': '人脸相机',
    '2': '考勤相机',
    '3': '采集相机',
  },

  PLAN_STATUS: {
    '0': '未统计',
    '1': '已统计'
  },
  PLAN_EXECUSTE_STATUS: {
    '1': '正常',
    '2': '迟到',
    '3': '早退',
    '4': '旷工',
    '5': '休假',
  },
  kEY_CARD_TYPE: {
    229: '期卡',
    226: '管理卡',
    227: '操作员卡',
    228: '贵宾卡',
    230: '临时卡',
  },
  KEY_STATUS: {
    '1': '正常',
    '2': '挂失',
    '3': '退卡'
  },
  KEY_TYPE: {
    '1': 'IC卡', '2': '人脸识别', '3': 'APP', '4': '二维码', '5': '动态码', '6': '指纹', '7': 'ID卡', '8': '静脉'
  },
  PASSWORD_LEVEL: {
    '1': '可修改',
    '0': '不可修改',
  },
  REPORT_TYPE: {
    'day': '按日',
    'week': '按周',
    'month': '按月',
    'year': '按年',
  },
  PUBLIC_ISVALID: {
    '0': '有效',
    '1': '无效',
  },
  APPLY_STATUS: {
    '0': '未审核',
    '1': '通过',
    '2': '拒绝',
    '3': '失效',
  },
  IS_LEAVE: {
    '1': '离开',
    '0': '滞留',
  },
  DEVICE_VERSION: {
    '1': '1.0',
    '2': '2.0',
  },
  DOOR_TYPE: {
    '1': '项目大门',
    '2': '楼宇',
    '3': '项目内部',
  },
  TALKBACK_CODEC: {
    'opus': 'opus',
    'ISAC': 'ISAC',
    'VP8': 'VP8',
    'VP9': 'VP9',
    'H264': 'H264',
    'H264 Baseline': 'H264 Baseline',
    'H264 High': 'H264 High'
  }, 
  TALKBACK_VERSION: {
    '1': '1.0',
    '2': '2.0',
  },
  USER_BLACK_TYPE: { 
    '1': '身份证', 
    '2': '手机号', 
    '3': '微信ID',
  },
  DOOR_OPEN_TYPE: {
    '1': '可进',
    '2': '可出',
    '3': '可进出',
    '0': '无效',
  },
  PAY_STATUS: {
    '1': '未支付',
    '2': '支付成功',
    '3': '支付失败',
    '4': '未到支付宝',
  },
  PAY_TYPE: {
    '1': '微信',
    '2': '支付宝',
  },
  DOOR_CLOSE_CONTROL: {
    '0': '自动延时关',
    '1': '读卡关'
  },
  DOOR_READER_TYPE: {
    '0': '无效', '1': 'G26读头', '2': 'WG34读头', '3': 'RS485的ID读头', '4': 'IC读头', '5': '其他存储卡', '6': 'RS485的带数据身份识别', '7': 'WiFi'
  },
  KEY_WEEK: {
    '1': '日',
    '2': '一',
    '3': '二',
    '4': '三',
    '5': '四',
    '6': '五',
    '7': '六',
  },
  CARD_TYPE: {
    '1': '月卡',
    '2': '次卡',
    '3': '共享卡'
  },
  CARD_LEVEL: {
    '1': '1',
    '2': '2',
    '3': '3',
    '4': '4',
    '5': '5',
    '6': '6',
    '7': '7',
    '8': '8',
    '9': '9',
  },
  DOWNLOAD_MESSAGE: {
    '1': '设备初始化',
    '2': '下载设备配置参数',
    '3': '读取设备配置参数',
    '4': '同步时间',
    '5': '写出厂配置参数',
    '6': '读出厂配置参数',
    '7': '初始化基础时段',
    '8': '下载基础时段',
    '9': '读基础时段',
    '10': '删除基础时段',

   // 门禁
   '2000': '设备初始化',
   // public final static int DOOR_C01H = 0x01;
   '2001': '设写配置参数',
   // public final static int DOOR_C02H = 0x02;
   '2003': '读配置参数',
   // public final static int DOOR_C03H = 0x03;
   '2004': '同步时间',
   // public final static int DOOR_C04H = 0x04;
   '2005': '写出厂配置参数',
   // public final static int DOOR_C05H = 0x05;
   '2006': '读出厂配置参数',
   // public final static int DOOR_C06H = 0x06;
   '2007': '初始化时间段设置',
   // public final static int DOOR_C07H = 0x07;
   '2008': '下载时间段设置',
   // public final static int DOOR_C08H = 0x08;
   '2009': '查询时间段设置',
   // public final static int DOOR_C09H = 0x09;
   '2010': '删除时间段设置',
   // public final static int DOOR_C0AH = 0x0A;
   '2011': '初始化基础时段',
   // public final static int DOOR_C0BH = 0x0B;
   '2012': '下载基础时段',
   // public final static int DOOR_C0CH = 0x0C;
   '2014': '查询基础时段',
   // public final static int DOOR_C0DH = 0x0D;
   '2013': '删除基础时段',
   // public final static int DOOR_C0EH = 0x0E;
   '2015': '初始化定时开关时间',
   // public final static int DOOR_C0FH = 0x0F;
   '2016': '修改定时开关时间',
   // public final static int DOOR_C10H = 0x10;
   '2018': '查询定时开关时间',
   // public final static int DOOR_C11H = 0x11;

   '2059': '初始化假日权限',
   // public final static int DOOR_C12H = 0x12;
   '2060': '修改假日权限',
   // public final static int DOOR_C13H = 0x13;
   '2062': '查询假日权限',
   // public final static int DOOR_C14H = 0x14;
   '2019': '初始化权限组',
   // public final static int DOOR_C15H = 0x15;
   '2020': '下载权限组',
   // public final static int DOOR_C17H = 0x17;
   '2021': '删除权限组',
   // public final static int DOOR_C16H = 0x16;
   '2022': '查询权限组',
   // public final static int DOOR_C18H = 0x18;
   '2023': '写设备信息',
   // public final static int DOOR_C19H = 0x19;
   '2024': '读设备信息',
   // public final static int DOOR_C1AH = 0x1A;
   '2025': '初始化黑名单',
   // public final static int DOOR_C1BH = 0x1B;
   '2026': '下载黑名单',
   // public final static int DOOR_C1CH = 0x1C;
   '2028': '查询黑名单',
   // public final static int DOOR_C1DH = 0x1D;
   '2027': '删除黑名单',
   // public final static int DOOR_C1EH = 0x1E;
   '2029': '初始化白名单',
   // public final static int DOOR_C1FH = 0x1F;
   '2030': '下载白名单',
   // public final static int DOOR_C20H = 0x20;
   '2031': '删除白名单',
   // public final static int DOOR_C21H = 0x21;
   '2032': '查询白名单',
   // public final static int DOOR_C22H = 0x22;
   '2033': '初始化用户密码',
   // public final static int DOOR_C23H = 0x23;
   '2034': '下载用户密码',
   // public final static int DOOR_C24H = 0x24;
   '2035': '删除用户密码',
   // public final static int DOOR_C25H = 0x25;
   '2036': '查询用户密码',
   // public final static int DOOR_C26H = 0x26;
   '2040': '收集当前开门记录',
   // public final static int DOOR_C28H = 0x28;
   '2041': '收集下一条开门记录',
   // public final static int DOOR_C29H = 0x29;
   '2042': '收集当前开关机记录',
   // public final static int DOOR_C2AH = 0x2A;
   '2043': '收集并清理开关机记录',
   // public final static int DOOR_C2BH = 0x2B;
   '2042': '远程门控制',
   // public final static int DOOR_C2CH = 0x2C;
   '2043': '远程复位',
   // public final static int DOOR_C2DH = 0x2D;
    // 梯控
    '1001': '设备初始化',
    //  final static int LIFT_C01H = 0x01;
    '1002': '设写配置参数',
    //  final static int LIFT_C02H = 0x02;
    '1003': '读配置参数',
    //  final static int LIFT_C03H = 0x03;
    '1004': '设置时间',
    //  final static int LIFT_C04H = 0x04;
    '1005': '写出厂配置参数',
    //  final static int LIFT_C05H = 0x05;
    '1006': '读出厂配置参数',
    //  final static int LIFT_C06H = 0x06;
    '1007': '初始化从设备配置表',
    //  final static int LIFT_C07H = 0x07;
    '1008': '写从设备配置表',
    //  final static int LIFT_C08H = 0x08;
    '1009': '读从设备配置表',
    //  final static int LIFT_C09H = 0x09;
    '1010': '初始化时间段设置',
    //  final static int LIFT_C0AH = 0x0A;
    '1011': '下载时间段设置',
    //  final static int LIFT_C0BH = 0x0B;
    '1012': '查询时间段设置',
    //  final static int LIFT_C0CH = 0x0C;
    '1013': '删除时间段设置',
    //  final static int LIFT_C0DH = 0x0D;
    '1014': '初始化有效时段参数',
    //  final static int LIFT_C0EH = 0x0E;
    '1015': '下载有效时段',
    //  final static int LIFT_C0FH = 0x0F;
    '1016': '查询有效时段',
    //  final static int LIFT_C10H = 0x10;
    '1017': '删除有效时段',
    //  final static int LIFT_C11H = 0x11;
    '1018': '初始化定时开放时间',
    //  final static int LIFT_C12H = 0x12;
    '1019': '修改定时开放时间',
    //  final static int LIFT_C13H = 0x13;
    '1020': '查询定时开放时间',
    //  final static int LIFT_C14H = 0x14;
    '1021': '删除时开放时间',
    //  final static int LIFT_C15H = 0x15;
    '1022': '初始化假日权限',
    //  final static int LIFT_C16H = 0x16;
    '1023': '修改假日权限',
    //  final static int LIFT_C17H = 0x17;
    '1024': '查询假日权限',
    //  final static int LIFT_C18H = 0x18;
    '1025': '初始化权限分组表',
    //  final static int LIFT_C19H = 0x19;
    '1026': '下载权限组',
    //  final static int LIFT_C1AH = 0x1A;
    '1027': '查询权限组',
    //  final static int LIFT_C1BH = 0x1B;
    '1028': '删除权限组',
    //  final static int LIFT_C1CH = 0x1C;
    '1029': '初始化层设置表',
    //  final static int LIFT_C1DH = 0x1D;
    '1030': '下载楼层设置',
    //  final static int LIFT_C1EH = 0x1E;
    '1031': '查询楼层设置',
    //  final static int LIFT_C1FH = 0x1F;
    '1032': '删除楼层设置',
    //  final static int LIFT_C20H = 0x20;
    '1033': '写设备信息',
    //  final static int LIFT_C21H = 0x21;
    '1034': '读设备信息',
    //  final static int LIFT_C22H = 0x22;
    '1035': '初始化黑名单',
    //  final static int LIFT_C23H = 0x23;
    '1036': '下载黑名单',
    //  final static int LIFT_C24H = 0x24;
    '1037': '查询黑名单',
    //  final static int LIFT_C25H = 0x25;
    '1038': '删除黑名单',
    //  final static int LIFT_C26H = 0x26;
    '1039': '初始化白名单',
    //  final static int LIFT_C27H = 0x27;
    '1040': '下载白名单',
    //  final static int LIFT_C28H = 0x28;
    '1041': '删除白名单',
    //  final static int LIFT_C29H = 0x29;
    '1042': '查询白名单',
    //  final static int LIFT_C2AH = 0x2A;
    '1043': '远程控制',
    //  final static int LIFT_C2BH = 0x2B;
    '1044': '远程选层',
    //  final static int LIFT_C2CH = 0x2C;
    '1045': '远程复位',
    //  final static int LIFT_C2DH = 0x2D;
    '1047': '收集当前记录',
    //  final static int LIFT_C2FH = 0x2F;
    '1048': '收集下一条记录',
    //  final static int LIFT_C30H = 0x30;
    '1049': '下载失效的二维码',
    //  final static int LIFT_C31H = 0x31;
    '1083': '下载指纹模版',
    //  final static int LIFT_C53H = 0x53;
    '1084': '清除指定ID指纹模版',
    //  final static int LIFT_C54H = 0x54;
    '1085': '清除所有指纹模版',
    //  final static int LIFT_C55H = 0x55;
    '1051': '远程蜂鸣',
    //  final static int LIFT_C33H = 0x33;
    
    '1000000': '重新登录',
    '-96': '门禁监控信息',
    '-97': '梯控监控信息',
    '-1014': '设备未注册',
    '-1012': '没找到命令类型',
  },
  DOWNLOAD_ERROR: {
    '0': '成功',
    '-1': '失败',
    '-2': 'token异常',
    '-3': '处理异常',
    '-4': '数据为空',
    '-5': '协议解析失败',
    '-6': '未定义的错误码',

    '-1000': 'websocket登录失败',
    '-1001': 'websocket未登录',
    '-1002': '没有查找到设备',
    '-1003': '没有查找到项目',
    '-1004': '没有找到操作类型',
    '-1005': '不支持的设备类型',
    '-1006': '没有找到设备时间',
    '-1007': '没有找到时间段',
    '-1008': '没有找到门',
    '-1009': '没有找到节假日',
    '-1010': '没有找到黑名单',
    '-1011': '没有找到白名单',
    '-1012': '没有找到命令类型',
    '-1013': '没有找到设备组',
    '-1014': '设备未注册',
    '-1015': '没有到开放时间',
    '-1016': '没有到楼层',
    '-1017': '没有到指纹文件',
    '-1018': '没有到消息类型', 
    '-1019': '发送失败', 
    '-1020': '超时', 
 
    '-128': '不支持命令',
    '-127': '未知错误',
    '-126': '长度错误（命令数据单元数据长度不合法）',
    '-125': '无效数据',
  },
  SUB_DEVICE_PROPERTY: {
    '1': '其他设备',
    '2': '指纹采集器',
    '3': '指静脉采集器'
  },
  LIFT_PWDTYPE: {
    '0': '密码不可用',
    '1': '密码限次',
    // '2': '密码不限次'
  },
  SEX_TYPE: {
    '1': '男',
    '2': '女',
  },
  WS: {
    DOWNLOAD_KEY: 10,
    QUERY_DOWNLOAD_KEY: 20
  },
  SUCCESS: '0', //  '账号尚未登录成功'
  ERROR_TOKEN: 3, //  '账号尚未登录成功'
  ERROR_NOT_LOGGED: 400, //  '账号尚未登录成功'
  ERROR_PRODUCT_AUTH: 37, //  '无权访问当前产品信息'
  ERROR_SAFE_LIMIT_ERROR: 36, //  '超过安全限制，需要重新登陆后操作'

  USER_TYPE_RESIDENT: '1',
  USER_TYPE_TENANT: '2',
  USER_TYPE_VISITOR: '3', 
  KEY_TYPE_ICCARD: '1',
  KEY_TYPE_AVATAR: '2',
  KEY_TYPE_APP: '3',
  KEY_TYPE_QRCODE: '4',
  KEY_TYPE_VERIFYCODE: '5',
  KEY_TYPE_FINGER: '6',
  KEY_TYPE_IDCARD: '7',
  KEY_TYPE_VEIN: '8', 
  SYSTEM_LIFT: '1',
  SYSTEM_DOOR: '2',
  SYSTEM_TALKBACK: '3',
  DOOR_TYPE_OUTSIDE: '1', // 项目大门
  DOOR_TYPE_BUILD: '2', // 楼宇
  DOOR_TYPE_INSIDE: '3', // 项目内部 
  DOOR_OPEN_TYPE_IN: '1', // 可进
  DOOR_OPEN_TYPE_OUT: '2', // 可出
  DOOR_OPEN_TYPE_INOUT: '3', // 可进出
  DOOR_OPEN_TYPE_NO: '0', // 无效 
  MANAGER_LEVEL_ESTATE: 2, // 项目管理员
  MANAGER_LEVEL_COMPANY: 1, // 公司管理员
  TALKBACK_TYPE_ESTATE: 5, // 项目大门对讲器
  TALKBACK_TYPE_BUILD: 3, // 楼宇对讲器
  TALKBACK_TYPE_ROOM: 4, // 室内对讲器
  DEVICE_TYPE_IC: 1, // 1 IC卡, 2 人脸识别, 3 APP, 4 二维码,5 动态码,6指纹,7ID,8静脉  A梯控 B门禁
  DEVICE_TYPE_AVATAR: 2,
  DEVICE_TYPE_APP: 3,
  DEVICE_TYPE_QRCODE: 4,
  DEVICE_TYPE_VERIFYCODE: 5,
  DEVICE_TYPE_FINGER: 6,
  DEVICE_TYPE_ID: 7,
  DEVICE_TYPE_VEIN: 8, 
  DEVICE_TYPE_LIFT: 'A',
  DEVICE_TYPE_DOOR: 'B',
  SUB_DEVICE_TYPE_CAMERA: '100', // 对于数据库 base_sub_device_type
  SUB_DEVICE_TYPE_IDCARD: '36', // 对于数据库 base_sub_device_type
  DEVICE_BRAND_ZHONGTONG: 1, // 对于数据库 base_brand
  DEVICE_BRAND_HANYUE: 2, // 对于数据库 base_brand
  
}
export default constant



// WEBPACK FOOTER //
// ./src/utils/constant.js